// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltips_tooltip__as-9z","tooltipLong":"Tooltips_tooltipLong__PQZM6","label":"Tooltips_label__RcM2o","line":"Tooltips_line__W0Zpe"};